import React, { useState, useEffect } from 'react';
import { Routes, Route } from "react-router-dom";
import { io } from "socket.io-client";
import { useDispatch, useSelector } from "react-redux";
import Login from './pages/Login.js';
import Register from './pages/Register.js';
import Blank from './pages/Blank.js';
import Home from './pages/Home.js';
import Room from './pages/Room.js';
import Dashboard from './pages/admin/Dashboard.js';
import AdminUsers from './pages/admin/AdminUsers.js';
import UserLocationManagement from './pages/UserLocationManagement.js';
import Feedback from './pages/admin/Feedback.js';
import Analytics from './pages/admin/Analytics.js';
import CannedMessagesPage from './components/CannedMessages/CannedMessagesPage.js';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Modal from "react-bootstrap/Modal";
import {
  getLoginStatus, getUser, selectIsLoggedIn, selectUser,
} from "./redux/features/auth/authSlice";
import SocketContext from "./context/SocketContext";

axios.defaults.withCredentials = true;

// Initialize socket with reconnection configuration
const socket = io.connect(process.env.REACT_APP_BACKEND_URL, {
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  reconnectionAttempts: 5,
});

// Add connection event handlers
socket.on('connect', () => {
  console.log('✅ Socket connected:', socket.id);
});

socket.on('disconnect', (reason) => {
  console.log('❌ Socket disconnected:', reason);
  if (reason === 'io server disconnect') {
    // Server disconnected, manually reconnect
    socket.connect();
  }
});

socket.on('reconnect', (attemptNumber) => {
  console.log('🔄 Socket reconnected after', attemptNumber, 'attempts');
  toast.success('Connection restored!', { autoClose: 2000 });
});

socket.on('reconnect_attempt', (attemptNumber) => {
  console.log('🔄 Reconnection attempt:', attemptNumber);
});

socket.on('reconnect_error', (error) => {
  console.error('❌ Reconnection error:', error);
});

socket.on('reconnect_failed', () => {
  console.error('❌ Reconnection failed');
  toast.error('Unable to connect to server. Please refresh the page.', { autoClose: false });
});

function App() {

  const [modalVisible, setModalVisible] = useState(false);

  const dispatch = useDispatch();
  const isLoggedIn = useSelector(selectIsLoggedIn);
  // const user  = useSelector((state) => state.auth);
  const user = useSelector(selectUser);
  // console.log(user);
  useEffect(() => {
    // Dispatch only once on mount
    dispatch(getLoginStatus());
  }, [dispatch]);

  useEffect(() => {
    // Fetch user data only if logged in and user data is not already fetched
    if (isLoggedIn && user === null) {
      dispatch(getUser());
    }

    if (isLoggedIn) {
      // Show modal immediately after login
      //setModalVisible(true);

      // Set interval to show modal every minute
      //const interval = setInterval(() => {
      //setModalVisible(true);
      //}, 1800000); //30mnt

      // Cleanup interval on unmount
      //return () => clearInterval(interval);
    }

  }, [dispatch, isLoggedIn, user]);

  const closeModal = () => {
    setModalVisible(false);
  };


  return (
    <>
      <ToastContainer />
      <SocketContext.Provider value={socket}>
        <Routes>
          {/*<Route path="/blank" element={
              <Blank/>
          }/>
          <Route path="/:id" element={
              <Login/>
          }/>*/}
          <Route path="/login" element={
            <Login />
          } />
          <Route path="/register" element={
            <Register />
          } />
          <Route exact path="/" element={
            <Home socket={socket} />
          } />
          <Route path="/room/:roomId" element={
            <Room />
          } />
          <Route path="/canned-messages" element={<CannedMessagesPage />} />
          <Route path="/admin/dashboard" element={
            <Dashboard />
          } />
          <Route path="/admin/users" element={
            <AdminUsers />
          } />
          <Route path="/user-location-management" element={
            <UserLocationManagement />
          } />
          <Route path="/admin/feedback" element={
            <Feedback />
          } />
          <Route path="/admin/analytics" element={
            <Analytics />
          } />
        </Routes>
      </SocketContext.Provider>

      {/* Modal */}
      <Modal show={modalVisible} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Reminder</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Dear Student,
          </p>
          <p>
            We are currently performing maintenance activities to enhance your experience. To ensure you receive all updated messages, we kindly request you to refresh your chats periodically.
          </p>
          <p>
            Thank you for your understanding and cooperation as we strive to provide you with the best possible service.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn infoModalBtn" onClick={closeModal}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default App;